import identity from "lodash/fp/identity";
class CountriesPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Countries",
      state: "countries",
      name: "countries",
    };

    this.filters = [
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "Country",
        state: "country",
        size: 25,
      },
    ];

    this.fields = [
      { title: "Country Name", name: "name", isSortable: true },
      { title: "Country Code", name: "code", isSortable: true },
      { title: "Corporates Contact Email", name: "corporates_contact_email" },
    ];
  }

  justify(data) {
    return identity(data);
  }
}

export default CountriesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/countries/countries.transforms.js